import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { SubCategoryDTO,CategoryDTO, TagDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class tagService implements OnInit {
    public Source:LocalDataSource;

    constructor(private http: HttpClient,private notifcationService:NotificationService) {
        this.Source = new LocalDataSource();
    }

    getTags():any{
       return this.http.get<TagDTO[]>(environment.apiUrl + "/Tag")
       .pipe(
        catchError(this.handleError)
       );
    }

    addTag(tagDTO:TagDTO){
        return this.http.post(environment.apiUrl + "/Tag", tagDTO).subscribe(
            data => {
                this.notifcationService.showSuccess("Tag", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Tag", "ajout avec success");
                console.error(error);
            }
        );



    }

    updateTag(Tag: TagDTO) {

        return this.http.put(environment.apiUrl + "/Tag", Tag).subscribe(
            data => {
                this.notifcationService.showSuccess("Tag", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Tag", "ajout avec success");
                console.error(error);
            }
        );

    }

    

    deleteTag(idTag:number){
        this.http.delete<any>(environment.apiUrl + "/Tag/"+idTag).subscribe(
            data => {
                this.notifcationService.showSuccess("Tag", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Tag", "suppression avec success");
                console.error(error);
            }
        );
    }



    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error.status}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
      };



}